import React, { useContext, useState, useEffect } from 'react';
import { useNavigate, Link } from "react-router-dom";
import { Form, Button, Container, Row } from "react-bootstrap";
import { ToastContainer } from 'react-toastify';
import AuthContext from '../../context/AuthContext';
import BusyLoaderOverlay from '../reusables/BusyLoaderOverlay';


export default function Login() {
    const navigate = useNavigate()
    let { userDetails, onPressSignIn } = useContext(AuthContext)
    const [loading, setLoading] = useState(false);
    const [signInErrors, setSignInErrors] = useState({
        email_id: "",
        password: "",
    });
    const [signInState, setSignInState] = useState({
        email_id: "",
        password: "",
    });

    const onChange = (oEvent) => {
        setSignInState({
            ...signInState,
            [oEvent.target.name]: oEvent.target.value,
        });
        if (!!signInErrors[oEvent.target.name])
            setSignInErrors({
                ...signInErrors,
                [oEvent.target.name]: null,
            });
    };

    useEffect(() => {
        if (userDetails) {
            setLoading(false);
            navigate("/appointment", { replace: true });
        }
    }, [userDetails]);

    return (
        <>
            <Container className="mb-3 ms-md-3 me-md-3">
                <Row>
                    <div className='col-md-12'>
                        <div className='content-section col-md-8'>
                            <legend className="border-bottom mb-4">Sign In</legend>
                            <Form autoComplete="off" noValidate>
                                <Form.Group className="mb-3" controlId="formEmailAddress">
                                    <Form.Label>Email Address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email_id"
                                        value={signInState.email_id}
                                        onChange={onChange}
                                        isInvalid={signInErrors.email_id}
                                    />
                                    <Form.Text className="text-muted">We'll never share your email address with anyone else.</Form.Text>
                                    <Form.Control.Feedback type="invalid">{signInErrors.email_id}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formPassword">
                                    <Form.Label>Password</Form.Label>
                                    <Form.Control
                                        type="password"
                                        name="password"
                                        value={signInState.password}
                                        onChange={onChange}
                                        isInvalid={signInErrors.password}
                                    />
                                    <Form.Control.Feedback type="invalid">{signInErrors.password}</Form.Control.Feedback>
                                </Form.Group>

                                <Form.Group className="mb-3" controlId="formLogin">
                                    <Button type="submit" variant="primary" className="form-control" disabled={loading} onClick={
                                        async (oEvent) => {
                                            oEvent.preventDefault();
                                            setLoading(true);
                                            try {
                                                await onPressSignIn(oEvent, signInState, setSignInState, setSignInErrors)
                                            } finally {
                                                setLoading(false);
                                            }
                                        }}>
                                        {loading ? 'Logging in...' : 'Login'}
                                    </Button>
                                </Form.Group>

                                <Form.Group className="mb-3 d-flex justify-content-end">
                                    <small>
                                        <Link
                                            to="/user/reset-password"
                                            style={{ textDecoration: "auto" }}
                                            className="text-muted">
                                            Forgot Password?
                                        </Link>
                                    </small>
                                </Form.Group>
                            </Form>
                        </div>
                    </div>
                </Row>
                <ToastContainer />
                <BusyLoaderOverlay show={loading} />
            </Container>
        </>
    );
}